import MarkdownIt from 'markdown-it'

const markdown = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
})

export function isRichTextHtml(value?: string | null) {
  return /<\/?(?:p|h[1-6]|ul|ol|li|blockquote|pre|table|div|span|img|a|strong|em|u|s|code|hr|br)\b/i.test(
    value ?? '',
  )
}

export function markdownToHelpHtml(value: string) {
  const trimmed = value.trim()
  if (!trimmed) return ''
  if (isRichTextHtml(trimmed)) return trimmed
  return markdown.render(trimmed).trim()
}

export function getHelpBodyPlainText(value?: string | null) {
  const content = value ?? ''
  if (!content) return ''

  if (typeof document !== 'undefined' && isRichTextHtml(content)) {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = content
    return wrapper.textContent ?? ''
  }

  return content.replace(/[#*_>`~-]/g, '').trim()
}

export function hasHelpBodyContent(value?: string | null) {
  const content = value ?? ''
  return (
    getHelpBodyPlainText(content).trim().length > 0 ||
    /<(?:img|iframe)\b/i.test(content)
  )
}
